import React, { useMemo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import Placeholder from 'components/consumer/Placeholder';
import JBImage from 'components/essentials/JBImage';
import IconTick from 'components/icons/iconTick';
import useScreen from 'hooks/useScreen';
import getOrientationOptionIcon from '../helpers/getOrientationOptionIcon';
const getPathSlug = location => {
  const params = location.pathname.split('/').filter(v => !!v);
  return params[params.length - 1] || '';
};
const PDPImageAndTextOption = ({
  loading,
  optionValue = {},
  selectedId,
  onOptionValueSelection,
  variant = 'regular',
  toggleFlyOut
}) => {
  const {
    isMobile
  } = useScreen();
  const location = useLocation();
  const pathSlug = getPathSlug(location);
  const optionValueId = optionValue.id;
  const {
    isDisabled
  } = optionValue;
  const {
    content = {}
  } = optionValue;
  const imgProps = variant === 'regular' ? {
    height: '58'
  } : {
    sizes: '25vw'
  };
  const isSelected = optionValueId === selectedId;
  const {
    image = null,
    customItem = null
  } = useMemo(() => getOrientationOptionIcon(optionValue.value?.trim(), optionValue.sku, location.pathname, pathSlug), [location.pathname, optionValue.sku, optionValue.value, pathSlug]);
  return <Placeholder type="rect" loading={loading} className="min-w-[150px] min-h-[60px] flex lg:min-w-[143px]">
      <div role="radio" tabIndex={0} className={classNames('bg-white justify-start min-h-[58px] min-w-[144px] flex flex-row items-center relative rounded p-px mt-0 mr-3 mb-3 ml-0 border border-solid lg:max-w-[142px] lg:min-w-[142px] hover:cursor-pointer', '[&:nth-of-type(3n+0)]:lg:mr-0', {
      'border-gray-light6 hover:border-gray-light2': !isSelected,
      'border-white hover:border-white shadow-[inset_0_0_0_1px_#262626]': isSelected,
      '!shadow-[inset_0_0_0_1px_#262626,inset_0_0_0_3px_#fff] hover:!cursor-not-allowed': isDisabled
    })} onClick={() => {
      if (isDisabled) {
        return;
      }
      if (isMobile) {
        toggleFlyOut(true, optionValueId);
      }
      onOptionValueSelection(optionValueId);
    }} onMouseEnter={!isMobile ? () => toggleFlyOut(true, optionValueId) : null} onMouseLeave={!isMobile ? () => toggleFlyOut(false, optionValueId) : null} aria-checked={isSelected}>
        {content.image && variant !== 'textOnly' ? <div className="flex-1 h-[58px] w-[58px] [&_svg]:h-11 [&_svg]:w-11 [&_svg]:m-2" key={content.image}>
            {!customItem ? <JBImage src={image || content.image} {...imgProps} /> : customItem}
          </div> : null}
        {content.text ? <div className={classNames('text-sm flex-1 font-bold text-gray ml-3 mr-2', {
        'text-center': variant === 'textOnly' || !image && !content?.image && !customItem
      })} key={content.text}>
            {content.text}
          </div> : null}

        {isSelected && <div className={classNames('z-[1]', {
        'items-center bg-gray-dark flex h-4 justify-center absolute right-[calc(1rem_-_15px)] top-[calc(1rem_-_15px)] w-4 rounded-none': isSelected,
        '[&_svg]:h-2.5 [&_svg]:w-2.5': isSelected,
        '[&_svg_path]:fill-white [&_svg_path]:stroke-white': isSelected
      })}>
            <IconTick height="22px" width="22px" />
          </div>}

        {isDisabled ? <>
            <div className={classNames({
          'absolute left-0 top-0 bg-[hsla(0,0%,100%,.4)] w-full h-full z-50': isDisabled
        })} />
            <div className={classNames({
          'absolute left-0 top-0 w-full h-full [background:linear-gradient(to_top_left,transparent_0,transparent_calc(50%_-_.8px)_,#000_50%,transparent_calc(50%_+_.8px)_,transparent)] z-[51] rounded-lg': isDisabled
        })} />
          </> : null}
      </div>
    </Placeholder>;
};
PDPImageAndTextOption.propTypes = {
  content: PropTypes.shape({
    image: PropTypes.string,
    text: PropTypes.string
  }),
  loading: PropTypes.bool,
  onOptionClick: PropTypes.func,
  onOptionValueSelection: PropTypes.func,
  optionId: PropTypes.number,
  optionValue: PropTypes.object,
  optionValueId: PropTypes.number,
  selectedId: PropTypes.number,
  toggleFlyOut: PropTypes.func,
  variant: PropTypes.oneOf(['regular', 'textOnly'])
};
export default PDPImageAndTextOption;